"use client";

import { c as _c } from "react/compiler-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, XCircleIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner, ToasterProps } from "sonner";

/**
 * Premium Outfame Toast Component
 *
 * Based on shadcn/ui implementation with Outfame styling.
 */
const Toaster = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      success: <CircleCheckIcon className="size-4 text-emerald-500" />,
      info: <InfoIcon className="size-4 text-blue-500" />,
      warning: <TriangleAlertIcon className="size-4 text-amber-500" />,
      error: <XCircleIcon className="size-4 text-red-500" />,
      loading: <Loader2Icon className="size-4 animate-spin text-gray-400" />
    };
    t2 = {
      classNames: {
        toast: "group toast bg-white text-gray-950 shadow-lg rounded-xl border border-gray-200",
        success: "border-l-[3px] border-l-emerald-500",
        error: "border-l-[3px] border-l-red-500",
        warning: "border-l-[3px] border-l-amber-500",
        info: "border-l-[3px] border-l-blue-500",
        loading: "border-l-[3px] border-l-gray-300"
      }
    };
    t3 = {
      "--normal-bg": "white",
      "--normal-text": "#141414",
      "--normal-border": "rgba(20,20,20,0.08)",
      "--border-radius": "12px"
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <Sonner className="toaster group" position="top-center" icons={t1} toastOptions={t2} style={t3 as React.CSSProperties} {...props} />;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { Toaster };